import { App as AntdApp } from 'antd';
import { ReactNode } from 'react';
import { Feedback } from '../feedback';

/**
 * 反馈组件的静态方法的前置组件,使用该组件是为了适配antd5 cssinjs 取消默认的降权操作时，反馈相关组件仍然使用低版本浏览器不兼容的:where选择器
 */
export function App(props: { children: ReactNode }) {
  const { children } = props;

  return (
    <AntdApp>
      <Feedback />
      {children}
    </AntdApp>
  );
}
